export function profileMenu() {
  const menuItems = Array.from(document.querySelectorAll('.toptech-profile-menu-item'));

  if (!menuItems.length) {
    return;
  }

  const closeMenu = (item, returnFocus = false) => {
    const trigger = item.querySelector(':scope > .toptech-profile-nav-link');
    const panel = item.querySelector(':scope > .toptech-profile-menu');

    if (!trigger || !panel) {
      return;
    }

    trigger.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    item.classList.remove('is-profile-menu-open');

    if (returnFocus) {
      trigger.focus();
    }
  };

  const closeOtherMenus = (currentItem) => {
    menuItems.forEach((item) => {
      if (item !== currentItem) {
        closeMenu(item);
      }
    });
  };

  menuItems.forEach((item) => {
    const trigger = item.querySelector(':scope > .toptech-profile-nav-link');
    const panel = item.querySelector(':scope > .toptech-profile-menu');

    if (!trigger || !panel) {
      return;
    }

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const shouldOpen = panel.hidden;

      closeOtherMenus(item);
      panel.hidden = !shouldOpen;
      trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      item.classList.toggle('is-profile-menu-open', shouldOpen);

      if (shouldOpen) {
        panel.querySelector('[role="menuitem"]')?.focus();
      }
    });

    item.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) {
        event.preventDefault();
        closeMenu(item, true);
      }
    });
  });

  document.addEventListener('click', (event) => {
    menuItems.forEach((item) => {
      if (!item.contains(event.target)) {
        closeMenu(item);
      }
    });
  });
}
